import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

// Cache the logo URL to avoid repeated fetches
let cachedLogoUrl: string | null = null;
let logoPromise: Promise<string | null> | null = null;

const fetchLogoFromDB = async (): Promise<string | null> => {
  const { data, error } = await supabase
    .from('settings')
    .select('value')
    .eq('key', 'company_logo')
    .maybeSingle();

  if (error && error.code !== 'PGRST116') {
    console.error('Error loading logo settings:', error);
    return null;
  }

  return (data?.value && typeof data.value === 'string') ? data.value : null;
};

export const useLogoSettings = () => {
  const [logoUrl, setLogoUrl] = useState<string>(cachedLogoUrl || '');
  const [loading, setLoading] = useState(!cachedLogoUrl);

  useEffect(() => {
    // If we already have a cached value, use it
    if (cachedLogoUrl !== null) {
      setLoading(false);
      return;
    }

    // If a fetch is already in progress, wait for it
    if (logoPromise) {
      logoPromise.then((url) => {
        if (url) {
          cachedLogoUrl = url;
          setLogoUrl(url);
        }
        setLoading(false);
      });
      return;
    }

    // Start a new fetch
    logoPromise = fetchLogoFromDB();
    logoPromise.then((url) => {
      if (url) {
        cachedLogoUrl = url;
        setLogoUrl(url);
      }
      setLoading(false);
      logoPromise = null;
    });
  }, []);

  const updateLogo = (url: string) => {
    cachedLogoUrl = url;
    setLogoUrl(url);
  };

  return { logoUrl, loading, updateLogo };
};